module.exports = __webpack_public_path__ + "img/Elo.f634541f.svg";